/* eslint-disable import/no-anonymous-default-export */
import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const login = async (data) => {
  try {
    return await request()
      .post(`/v2/user/login`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateMyAccount = async (data) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .put(`/v2/user/update/my-account`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateUser = async (data) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .put(`/v2/user/update`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const registerUser = async (data, token) => {
  try {
    return await request(token)
      .post(`/v2/user/register`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              data?.error ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getUser = async (token) => {
  try {
    return await request(token)
      .post(`/auth/me`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getUserEstablishment = async (token) => {
  const { user } = await getUser(token);
  if (!user && user?.establishments[0]) {
    return Notification(
      "Error",
      "Some went wrong! Please try again later!",
      "error"
    );
  }
  return user.establishments[0]["estId"];
};

/**
 * This uses v2 of user service
 * @param {*} token
 */
export const getAccounts = async (token) => {
  try {
    return await request(token)
      .get(`/v2/user`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response?.data ||
        error.response.data?.error ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

/**
 * This uses v2 of user service
 * @param {*} token
 */
export const changeUserStatus = async (id, status, token) => {
  try {
    return await request(token)
      .patch(`/v2/user/${id}?isActive=${status}`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};
